import { useEffect } from "react";
import { toast, Toaster } from "sonner";
import { useAuth } from "@/auth/AuthContext";

export default function AppNotifications() {
  const { user } = useAuth();
  const scope = user ? `${user.id}:${user.company_id}:${user.role}:${user.platform_role}` : "signed-out";
  useEffect(() => { toast.dismiss(); }, [scope]);
  return <Toaster richColors position="bottom-right" />;
}
